import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { CommonDataService } from '../../../shared/services/common-data.service';
import { PichCommonHttpService } from '../../services/pichincha-common-http.service';

import { PichBaseComponent } from '../pichincha-base.component';

import { PATHS } from '../../../shared/constants';
import { ConfirmationService } from '../../../vass-core/components/modal/confirmation.service';
import { InitialData } from '../../model/initial-data.model';
import { OptionsType } from '../../../shared/model/option-type.model';

/**
 * Pantalla de selección de país de residencia y tipo de cuenta.
 * El país de residencia lo elige el cliente (Ecuador, Colombia, Perú).
 * El tipo de cuenta se fija automáticamente a Miami Agency (L_PBM).
 */
@Component({
  selector: 'app-account-owner',
  templateUrl: './account-owner.component.html',
  styleUrls: ['./account-owner.component.scss']
})
export class AccountOwnerComponent extends PichBaseComponent implements OnInit {
  public action = PATHS.accountOwner;
  public dataRegister = {} as InitialData;
  public countriesList: OptionsType[] = [];
  public onBoardingformGroup: FormGroup;
  public countryObj: OptionsType;

  constructor(
    private routerC: Router,
    private pichCService: PichCommonHttpService,
    private commonDataService: CommonDataService,
    protected confirmationService: ConfirmationService,
    private fb: FormBuilder
  ) {
    super(routerC, pichCService, confirmationService);
  }

  ngOnInit() {
    this.countriesList = [
      { id: 1, name: 'Ecuador' },
      { id: 2, name: 'Colombia' },
      { id: 3, name: 'Perú' }
    ];

    Object.assign(this.dataRegister, this.commonDataService.getDataRegister());

    this.onBoardingformGroup = this.fb.group({
      country: [null, Validators.required]
    });

    this.loadFormPatchValue();
  }

  private loadFormPatchValue() {
    const { sourceCountry } = this.dataRegister;

    this.countryObj = this.countriesList.find((f) => f.name === sourceCountry);
    this.onBoardingformGroup.patchValue({
      country: this.countryObj?.id
    });
  }

  getAction() {
    return PATHS.accountOwner;
  }

  onNextStage() {
    if (this.onBoardingformGroup.valid) {
      const countryValue = this.onBoardingformGroup.value.country;
      this.dataRegister.sourceCountry = countryValue.name;
      this.dataRegister.targetCountry = 'L_PBM';
      this.dataRegister.privacyPolicy = 'L_PBM';
      const data = Object.assign({}, this.dataRegister);
      this.commonDataService.setDataRegister(data);
      this.routerC.navigate(['onboarding', PATHS.initialData]);
    } else {
      this.onBoardingformGroup.markAllAsTouched();
    }
  }

  onBackStage() {
    this.routerC.navigate(['onboarding', PATHS.welcome]);
  }
}
